export default __webpack_public_path__ + "static/media/Hamburger_icon_white.1238890a.svg";